/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PatientsTreatmentPlanPermissions } from './patientsTreatmentPlanPermissions';
import { PatientsPatientPracticeConsentPermissions } from './patientsPatientPracticeConsentPermissions';
import { PatientsPatientExportPermissions } from './patientsPatientExportPermissions';
import { PatientsTkEnrolmentPermissions } from './patientsTkEnrolmentPermissions';
import { PatientsPatientDiagnosisPermissions } from './patientsPatientDiagnosisPermissions';
import { PatientsPatientPermissions } from './patientsPatientPermissions';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientsPermissions { 
    patient: PatientsPatientPermissions;
    patientDiagnosis: PatientsPatientDiagnosisPermissions;
    patientExport: PatientsPatientExportPermissions;
    patientPracticeConsent: PatientsPatientPracticeConsentPermissions;
    tkEnrolment: PatientsTkEnrolmentPermissions;
    treatmentPlan: PatientsTreatmentPlanPermissions;
}
export const PatientsPermissions_patient_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPermissions_patientDiagnosis_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPermissions_patientExport_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPermissions_patientPracticeConsent_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPermissions_tkEnrolment_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPermissions_treatmentPlan_Validators: ValidatorFn[] =
    [  Validators.required, ];


